export const languageCodes = {
    'English': 'en',
    'Arabic': 'ar',
    'Haitian_Creole': 'ht',
    'Polish': 'pl',
    'Portuguese': 'pt',
    'Serbian': 'sr',
    'Spanish' : 'es',
    'Vietnamese': 'vi',
    'Haitian_creole': 'ht'
    // 'zh': '确认',
    // 'ne': 'पुष्टि गर्नुहोस्'
}